import { IonContent } from "@ionic/react"

export const FundamentosPopover: React.FC = ()=>{ 

    return(
        <IonContent class="ion-padding">
            Los minutos elegidos para el entrenamiento rápido son menores a los minutos que tenes disponible en los ejercicios elegidos
        </IonContent>
    )
}